<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import ArrowIcon from "@/ui/icons/arrow.vue";
import WIDGET_ANALYTICS_EVENTS from "~/tiw/helpers/widgetAnalyticsEvents/widgetAnalyticsEvents";
import { useAnalytics } from "~/tiw/hooks/useAnalytics/useAnalytics";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";
import { useTIWStore } from "~/tiw/stores/tiw/tiw";
import Button from "~/tiw/ui/button/button.vue";
import Checkbox from "~/tiw/ui/checkbox/checkbox.vue";

import Modal from "../../modal/modal.vue";

onMounted(() => {
    useAnalytics(WIDGET_ANALYTICS_EVENTS.CREDIT_CARD);
});

const TIWStore = useTIWStore();

const termsAndConditions = ref(false);
const processingPersonalData = ref(false);

const isAcceptedNext = computed(() => termsAndConditions.value && processingPersonalData.value);

function onBack() {
    TIWStore.switchStep("chooseRangeDiscount");
}

function onStart() {
    TIWStore.switchStep("creditCartPreAuthorizationPayment");
}
</script>

<template>
    <Modal class="tiw__step__creditCartPreAuthorization">
        <div class="tiw__step__creditCartPreAuthorization__body">
            <svg
                width="64"
                height="52"
                viewBox="0 0 64 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 17H62M2 26C2 15.389 2 10.082 5.159 6.539C5.665 5.971 6.219 5.449 6.821 4.973C10.586 2 16.223 2 27.5 2H36.5C47.777 2 53.414 2 57.176 4.97C57.78 5.45 58.335 5.973 58.841 6.539C62 10.079 62 15.389 62 26C62 36.611 62 41.918 58.841 45.461C58.3323 46.0302 57.7752 46.5541 57.176 47.027C53.414 50 47.78 50 36.5 50H27.5C16.223 50 10.586 50 6.821 47.03C6.22268 46.556 5.66659 46.0311 5.159 45.461C2 41.921 2 36.611 2 26Z"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26 38H30.5M39.5 38H50"
                    stroke="#6959CB"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div class="tiw__step__creditCartPreAuthorization__body__info">
                <p class="tiw__step__creditCartPreAuthorization__body__info__title">
                    {{ useTranslate("tiw__creditCardPreAuthorization__title") }}
                </p>
                <p class="tiw__step__creditCartPreAuthorization__body__info__text">
                    {{ useTranslate("tiw__creditCardPreAuthorization__text") }}
                </p>
            </div>
            <div class="tiw__step__creditCartPreAuthorization__body__actions">
                <Checkbox v-model="termsAndConditions">
                    <span v-html="useTranslate('tiw__creditCardPreAuthorization__accepted')" />
                </Checkbox>
                <Checkbox v-model="processingPersonalData">
                    <span v-html="useTranslate('tiw__creditCardPreAuthorization__agree')" />
                </Checkbox>
                <div class="tiw__step__creditCartPreAuthorization__body__actions__buttons">
                    <Button
                        type="button"
                        variant="skeleton"
                        class="tiw__step__chooseSigningType__btn-back"
                        @click="onBack"
                    >
                        <ArrowIcon />
                        <span>{{ useTranslate("tiw__back") }}</span>
                    </Button>
                    <Button :disabled="!isAcceptedNext" @click="onStart">
                        {{ useTranslate("tiw__start") }}
                    </Button>
                </div>
            </div>
        </div>
    </Modal>
</template>

<style lang="scss" src="./creditCartPreAuthorization.scss"></style>
